@if (!skjemaVises()) {
  <a (click)="visSkjema()" class="e2e-vis-eksterne"
     matTooltip="{{'Dersom du ønsker å registrere deltakere som ikke har bruker i Styreplan³, kan du registrerer disse som eksterne deltakere. Disse får ikke innkalling eller tilgang til Styreplan³.'|translate}}">
    {{ "Legg til eksterne deltakere"|translate }}
  </a>
} @else {
  <div>
    {{ "Eksterne deltakere"|translate }}
    @if (kunTommeRader()) {
      <a (click)="skjulSkjema()">({{ "skjul"|translate }})</a>
    }
  </div>

  <table class="e2e-eksternedeltakereskjema">
  @for (kontroller of skjema().controls; track indeks; let indeks = $index; let erSisteRad = $last) {
    <tr [formGroup]="kontroller" [ngClass]="{'slettet':kontroller.controls.slettet.value}" (keydown.enter)="$event.stopPropagation()" data-testid="deltaker" class="e2e-ekstern-deltaker">
      <td>
        <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dense-3">
          <input matInput formControlName="navn" placeholder="{{'Navn'|translate}}" (keydown.enter)="$event.stopPropagation()" data-testid="navn" class="e2e-navn">
          @if(kontroller.controls.navn.hasError('maxlength')){
            <mat-error data-testid="maxlength">{{kontroller.controls.navn.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
      </td>
      <td>
        <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dense-3">
          <input matInput formControlName="rolle" placeholder="{{'Rolle'|translate}}" data-testid="rolle" class="e2e-rolle">
          @if(kontroller.controls.rolle.hasError('maxlength')){
            <mat-error data-testid="maxlength">{{kontroller.controls.rolle.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
      </td>
      <td>
        <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dense-3">
          <input matInput formControlName="kommentar" placeholder="{{'Kommentar'|translate}}" data-testid="kommentar" class="e2e-kommentar">
          @if(kontroller.controls.kommentar.hasError('maxlength')){
            <mat-error data-testid="maxlength">{{kontroller.controls.kommentar.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
      </td><!-- viser ikke slett-knapp for siste rad -->
      <td>
        @if (!erSisteRad) {
          @if (kontroller.controls.slettet.value) {
            <!-- raden er slettet - viser knapp for å "angre" -->
            <button (click)="angreSlett(indeks)" mat-button type="button"  aria-label="Angre sletting av ekstern deltaker" data-testid="angre-slett">
              Angre slett
            </button>
          } @else {
            <!-- raden er IKKE slettet - viser knapp for å "slette" -->
            <button (click)="slett(indeks)" mat-icon-button type="button"  aria-label="Slett ekstern deltaker" class="mat-medium-icon-button e2e-slett" data-testid="slett">
              <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
            </button>
          }
       }
      </td>
    </tr>
  }
  </table>

  <tips>
   {{ "Merk at eksterne deltakere ikke får innkalling eller tilgang til Styreplan"|translate }}
  </tips>
}
